/* eslint-disable */
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CommonDatePicker = (props) => {
    const { dateRange, setDateRange, placeholderText, dependantState, daysValidation } = props;
    const [ startDate, endDate ] = dateRange;
    let today = new Date();
    
    const onChangeDate = (date) => {
        setDateRange(date);

        if(dependantState?.allow) {
            if(dependantState?.statType === "current_page") {
                if(date[1] !== null) {
                    dependantState?.stateFunction(1);
                };
            };
        };
    };

    const filterEndDate = (date) => {
        if (!startDate) return true; // Allow all dates if startDate is not selected
        const maxEndDate = new Date(startDate);
        maxEndDate.setDate(maxEndDate.getDate() + 15);
        return date <= maxEndDate;
    };
    
    return(<div className="datepickField_new min">
        {daysValidation === undefined ? (<DatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
                onChangeDate(update)
            }}
            maxDate={today}
            placeholderText={placeholderText}
            dateFormat="dd MMM, yyyy"
            isClearable={true}
        />) : (<DatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
                onChangeDate(update)
            }}
            maxDate={today}
            filterDate={(date) => {
                return !startDate || date <= today && filterEndDate(date);
            }}
            placeholderText={placeholderText}
            dateFormat="dd MMM, yyyy"
            isClearable={true}
        />)}
    </div>)
};

export default CommonDatePicker;